import jsCookie from 'js-cookie';

export const SEARCH_COOKIE = 'ha-trip-prst';

function getCookie(cookies, key) {
    let cookie;

    cookies.forEach((cook) => {
        const splittedCookie = cook.split('=');
        if (splittedCookie[0].trim() === key) {
            cookie = splittedCookie[1];
        }
    });

    return !cookie ? null : cookie;
}

function parseJSONCookie(cookie) {
    try {
        return JSON.parse(
            cookie.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
        );
    } catch (e) {
        return {};
    }
}

/**
 * @params {string|falsy} A cookie string (e.g. from the HTTP header 'Cookie' or
 *   document.cookie) or a falsy value
 * @returns {Object} The values in the search cookie or an empty object if they
 *   can't be read.
 */
export function getSearchCookie(cookies) {
    if (!cookies) {
        return {};
    }

    const parsedCookies = cookies.split(';');

    const searchCookie = getCookie(parsedCookies, SEARCH_COOKIE);

    return parseJSONCookie(searchCookie);
}

export function removeKeysFromSearchCookie(...keys) {
    const cookie = jsCookie.getJSON(SEARCH_COOKIE);

    if (!cookie) {
        return;
    }

    for (let key of keys) {
        delete cookie[key];
    }

    jsCookie.set(SEARCH_COOKIE, cookie);
}

export function removeDatesFromSearchCookie() {
    removeKeysFromSearchCookie('arrival', 'departure');
}

export function getHapiSearchCookie(cookies) {
    if (!cookies || !cookies[SEARCH_COOKIE]) {
        return null;
    }

    return parseJSONCookie(cookies[SEARCH_COOKIE]);
}
